/**
 * Normalizes the duration of a transition.
 * @param {number|object} duration The value to normalize.
 * @param {'hide'|'show'} type The type of transition.
 * @returns {number}
 */
export default (function (duration, type) {
  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
});


//////////////////
// WEBPACK FOOTER
// /home/gitlab_ci_multi_runner/builds/88e00e75/0/bryx911/ua-download/~/semantic-ui-react/dist/es/lib/normalizeTransitionDuration.js
// module id = 809
// module chunks = 0